import Nav from "@/components/landing/Nav";
import V2Background from "@/components/landing/V2Background";
import HeroSideStage from "@/components/landing/HeroSideStage";
import ClientLogos from "@/components/landing/ClientLogos";
import WhatWeDo from "@/components/landing/WhatWeDo";
import AllyAndVault from "@/components/landing/AllyAndVault";
import WhyNow from "@/components/landing/WhyNow";
import FAQ from "@/components/landing/FAQ";
import BookingCTA from "@/components/landing/BookingCTA";
import Footer from "@/components/landing/Footer";
import MobileStickyBar from "@/components/landing/MobileStickyBar";

// Hero = side-stage box (dome video right of text). Section backgrounds will use a
// looping texture video (V2Background, pending the texture asset) via .v2-stage frost.
export default function LandingV2() {
  return (
    <main className="v2-stage relative">
      <V2Background />
      <Nav variant="v2" />
      <HeroSideStage />
      <ClientLogos />
      <WhatWeDo />
      <AllyAndVault />
      <WhyNow />
      <FAQ />
      <BookingCTA />
      <Footer />
      <MobileStickyBar />
    </main>
  );
}
